import { sendHubspotForm as sendHubspotFormApi } from 'API/hubspot-api/hubspot-api';
import { HubSpotFieldNames, loginFormId } from 'features/authentication/utils/constants';
import { reportException } from 'core/exceptions';
import { heapIdentify } from 'utils/heap/heap';

type LoginFields = 'email' | 'password';

export const sendHubspotForm = (username: string) => {
    heapIdentify(username);

    let fields = [
        {
            name: HubSpotFieldNames.email,
            value: username,
        },
    ];

    sendHubspotFormApi<LoginFields | string>(loginFormId, fields).catch((error) => {
        reportException(error, {
            payload: {
                loginFormId,
                fields,
            },
            method: 'POST',
            status_code: error.statusCode,
            target_url: `${process.env.REACT_APP_HUBSPOT_PORTAL_ID}/${loginFormId}`,
        });
    });
};
